var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkMinimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 53.0807C14.1637 53.0807 2.91699 41.8341 2.91699 27.9974C2.91699 14.1607 14.1637 2.91406 28.0003 2.91406C41.837 2.91406 53.0837 14.1607 53.0837 27.9974C53.0837 41.8341 41.837 53.0807 28.0003 53.0807ZM28.0003 6.41406C16.1003 6.41406 6.41699 16.0974 6.41699 27.9974C6.41699 39.8974 16.1003 49.5807 28.0003 49.5807C39.9003 49.5807 49.5837 39.8974 49.5837 27.9974C49.5837 16.0974 39.9003 6.41406 28.0003 6.41406Z",
    fill: "#0AA71A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6855 36.3531C24.2188 36.3531 23.7755 36.1664 23.4488 35.8397L16.8454 29.2364C16.1687 28.5597 16.1687 27.4397 16.8454 26.7631C17.5221 26.0864 18.6421 26.0864 19.3187 26.7631L24.6855 32.1297L36.6788 20.1364C37.3555 19.4597 38.4755 19.4597 39.1522 20.1364C39.8288 20.8131 39.8288 21.9331 39.1522 22.6097L25.9222 35.8397C25.5955 36.1664 25.1522 36.3531 24.6855 36.3531Z",
    fill: "#0AA71A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkMinimal);
export default __webpack_public_path__ + "static/media/checkmark_minimal.9612785ed7eae970453e8c6cbef2c489.svg";
export { ForwardRef as ReactComponent };